const o = "_accordionRoot_9i5ki_1", n = "_accordionHeader_9i5ki_5", c = "_accordionItemHeading_9i5ki_11", e = "_accordionItemHeaderInnerWrapper_9i5ki_29", r = "_accordionItemHeader_9i5ki_29", a = "_expandIcon_9i5ki_72", i = "_accordionContent_9i5ki_84", d = "_accordionContentInnerWrapper_9i5ki_94", t = {
  accordionRoot: o,
  accordionHeader: n,
  accordionItemHeading: c,
  accordionItemHeaderInnerWrapper: e,
  accordionItemHeader: r,
  expandIcon: a,
  accordionContent: i,
  accordionContentInnerWrapper: d
};
export {
  i as accordionContent,
  d as accordionContentInnerWrapper,
  n as accordionHeader,
  r as accordionItemHeader,
  e as accordionItemHeaderInnerWrapper,
  c as accordionItemHeading,
  o as accordionRoot,
  t as default,
  a as expandIcon
};
